<template>
  <!-- <el-card :body-style="{ padding: '0px' }"> -->
  <el-card
    :body-style="{ padding: '0px' }"
    shadow="never"
    :style="{marginBottom:'15px',height:height}"
  >
    <!-- <p>{{screenWidth}}</p> -->
    <div >
      <img :src = "require(`../assets/images/${imgName}.jpg`)" class="image" />
      <div style="padding: 7px;">
        <span>{{descripte}}</span>
        <div class="bottom clearfix">
          <el-row type="flex" justify="space-around">
            <el-button >
              <a :href="shoplink" >More</a>
            </el-button>
          </el-row>
        </div>
      </div>
    </div>

  </el-card>
</template>
<style >
.text {
  font-size: 13px;
  color: #999;
}
.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 100%;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
a{text-decoration: none!important;}
</style>

<script>
export default {
  components: {},
  props: { productID: String, vendor: String, category: String },
  data() {
    return {
      height: '530px',
      showVendor: true,
      shoplink: '',
      descripte1: {
        shopee: 'Heltec Taiwan 蝦皮賣場',
        pchome: 'PCHOME 商店街 24hr到貨',

        yahoo: 'yahoo 拍賣',

      },
      descripte2: {
        shopee: '運用您的蝦幣 我們在蝦皮商城等您喔~',
        pchome: '官方經營 24hr 快速到貨',
        mamilove: '只給寶寶最好的',
        yahoo: 'Heltec Taiwan 官方經營 官方商店',
      },
      link: {
        shopee: 'https://shopee.tw/Heltec.taiwan',
        pchome: 'https://www.pcstore.com.tw/Heltec/',
        mamilove: 'https://mamilove.com.tw/groupbuy/search/?query=Heltec',
        yahoo: 'https://tw.bid.yahoo.com/booth/Y2124443058?bfe=1',
        malldj: 'https://www.malldj.com/Desktop/search.aspx?word=Heltec',
      },
      vendorLink: [
        {
          link: 'https://www.pcstore.com.tw/Heltec/',
          image: '../../static/images/pchome24hlogo.jpg',
          show: true,
        },
        {
          link: 'https://www.pcstore.com.tw/Heltec/',
          image: '../../static/images/shopeelogo.jpg',
          show: true,
        },
        {
          link: 'https://www.pcstore.com.tw/Heltec/',
          image: '../../static/images/mamiLoveLogo.jpg',
          show: true,
        },
        {
          link: 'https://www.pcstore.com.tw/Heltec/',
          image: '../../static/images/malldjLogo.jpg',
          show: true,
        },
        {
          link: 'https://www.pcstore.com.tw/Heltec/',
          image: '../../static/images/yahooLogo.jpg',
          show: true,
        },
      ],
      imgLink: '../assets/images/home1.jpg',
      imgName: 'home1',
      productTable: [
        {
          sku: 'HTCC-AM01',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000135211',
          descripte:
            'HTCC-AM01 is a Module. Supports AT transparent transmission commands, can be directly integrated into the application circuit.',
        },
        {
          sku: 'HTCC-AM02',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136102',
          descripte:
            'HTCC-AM02 is a Module. Supports AT transparent transmission commands, can be directly integrated into the application circuit.',
        },
        {
          sku: 'HTCC-AB02',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136106',
          descripte:
            'HTCC-AB02 is a Dev-Board. Friendly designed for developers, easy to verify communication solutions.',
        },
        {
          sku: 'HTCC-AB02A',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136106',
          descripte:
            'HTCC-AB02A is a Dev-Board. Friendly designed for developers, easy to verify communication solutions.',
        },
        {
          sku: 'HTCC-AB02S',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136107',
          descripte:
            'HTCC-AB02S is a Dev-Board. Already integrated AIR530 GPS module, friendly designed for developers, easy to verify communication solutions.',
        },
        {
          sku: 'HTCC-AC01',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136103',
          descripte:
            'HTCC-AC01 is a LoRa end node sensor. With a complete enclosure and protection measures, it can be deployed directly into real-world applications.',
        },
        {
          sku: 'HTCC-AC02',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136104',
          descripte:
            'HTCC-AC02 is a LoRa end node sensor. With a complete enclosure and protection measures, it can be deployed directly into real-world applications.',
        },
        {
          sku: 'HTCC-CPC01',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136297',
          descripte:
            'HTCC-CPC01 is a program convertable board for Hectel CubeCell serial.',
        },
        {
          sku: 'HTCC-AB01',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136105',
          descripte: 'HTCC-AB01 is a Dev-Board. Friendly designed for developers, easy to verify communication solutions.',
        },
        {
          sku: 'HTIT-WSL',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136113',
          descripte:
            'Wireless Stick Lite” has much better low power design (30uA in deep sleep). Removed the 0.49″ OLED, use ESP32-PICO MCU (it’s more friendly for low power design)',
        },
        {
          sku: 'HTIT-WS',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136112',
          descripte:
            '“Wireless Shell” is an ESP32-PICO + SX1276 module. provide Wi-Fi, BLE and LoRa solution. ',
        },
        {
          sku: 'HTIT-WST',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136111',
          descripte:
            'In order to meet the user’s requirements for high performance and small size, we designed this product. On the basis of WiFi LoRa 32, it’s has a smaller size, 0.49″ OLED display, and better RF characteristics.',
        },
        {
          sku: 'HTIT-WB32C',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136110',
          descripte: 'WiFi LoRa 32C is a integrated product based on HTIT-WB32-C, it has same spec as HTIT-WB32 and integrated a shell case to cover the PCB.',
        },
        {
          sku: 'HTIT-WB32',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136109',
          descripte: 'WiFi LoRa 32 is a highly integrated product based on ESP32 + SX127x, it has Wi-Fi, BLE, LoRa functions, also Li-Po battery management system, 0.96″ OLED are also included.',
        },
        {
          sku: 'HT-M00',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136114',
          descripte:
          'HT-M00 is a low-cost dual channel gateway.It is located to smart family LoRa applications that work with less than 30PCS LoRa nodes.',
        },
        {
          sku: 'HT-M01',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136115',
          descripte:
          'HT-M01 is a picocell LoRa gateway based SX1301 baseband chip, it support both SPI and USB interface can work with Windows® (7, 8, 10 or higher) or Linux (Raspberry Pi®). ',
        },
        {
          sku: 'HT-M02',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136116',
          descripte: 'HT-M02 is designed strictly with industrial standards, Integrated Linux OS, IP65,PoE power supply and 110 / 220V AC power supply version use 4G upload LoRa data.',
        },
        {
          sku: 'BATTERY-80',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136118',
          descripte:
          'BATTERY-80 is a Lithium Rechargeable Battery with 80mHA capacity and small package really suitable for CellCube series.',
        },
        {
          sku: 'BATTERY-1000',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136296',
          descripte:
          'BATTERY-1000 is a Lithium Rechargeable Battery suitable with 1000mHA capacity and 1.25 pitch jack suitable for CellCube and LoRa Node series.',
        },
        {
          sku: 'EZ-ANT',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136117',
          descripte: 'EZ-ANT is a series sub-1G antenna suitable for CellCube and LoRa Node product series. There are several antenna model to support different frequency application',
        },
        {
          sku: 'HTCC-BH1750',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136292',
          descripte:
         'HTCC-BH1750 is a extension board to perferm the Ambient Light Sensor.',
        },
        {
          sku: 'HTCC-BMP180',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136293',
          descripte:
          'HTCC-BMP180 is a extension board to perferm the barometric pressure sensor.',
        },
        {
          sku: 'HTCC-CCS811B',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136294',
          descripte:
          'HTCC-CCS811B is a extension board to perferm the Air Quality Sensor.',
        },
        {
          sku: 'HTCC-MPU9250',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136295',
          descripte:
          'HTCC-MPU9250 is a extension board to perferm the 9-Axis (Gyro + Accelerometer + Compass) MEMS Motion Tracking.',
        },
        {
          sku: 'HTCC-HDC1080',
          shoplink: 'https://heltec.cashier.ecpay.com.tw/product/000000000136119',
          descripte:
         'HTCC-HDC1080 is a extension board to perferm the digital humidity and temperature Sensor.',
        }],
      pchomeLink: '',
      shopeeLink: '',
      title: '',
      descripte: '',
      screenWidth: document.body.clientWidth,
    };
  },
  methods: {
    setData() {
      if (this.category !== 'vendor') {
        this.productTable.forEach((element) => {
          if (element.sku === this.productID) {
            this.descripte = element.descripte;
            this.shoplink = element.shoplink;
            this.imgName = this.productID;
            // console.log(this.productID);
          }
        });
      } else {
        this.imgName = this.vendor;
        // this.imgLink = '../../static/images/yahoo.jpg';
        this.vendorLink = this.link[this.vendor];
        this.descripteLink1 = this.descripte1[this.vendor];
        this.descripteLink2 = this.descripte2[this.vendor];
      }
    },
  },
  watch: {
    screenWidth(val) {
      if (!this.timer) {
        this.screenWidth = val;
        this.timer = true;
        const that = this;
        setTimeout(() => {
          that.init();
          that.timer = false;
        }, 400);
      }
    },
  },
  created() {
    const that = this;
    window.onresize = () => (() => {
      window.screenWidth = document.body.clientWidth;
      that.screenWidth = window.screenWidth;
    })();
    // this.handleResize();
  },
  mounted() {
    if (this.category === 'vendor') {
      this.showVendor = false;
      const n = 400 + (1280 / this.screenWidth) * 10;
      this.height = `${n}+"px"`;
      this.height = '380px';
    } else {
      this.showVendor = true;
    }
    this.setData();
    // console.log(this.screenWidth);
  },
  beforeDestroy() {
    // this.editor.destroy();
  },
};
</script>
